module.exports = "data:image/svg+xml,%3Csvg width='14' height='10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.602.449c.447.432.447 1.13 0 1.561L6.169 9.19a1.161 1.161 0 01-.809.324c-.292 0-.585-.109-.808-.324L.835 5.599a1.076 1.076 0 010-1.56 1.17 1.17 0 011.617 0L5.36 6.846 11.985.449a1.17 1.17 0 011.617 0z' fill='%23fff'/%3E%3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tick.svg
// module id = 22
// module chunks = 1